'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* HELD — not cleared for publication, and not routed.
 * WeFact has given no approval and no testimonial; `_held/` is a Next.js
 * private folder, so nothing here renders until the directory is moved up
 * one level. Same mechanism as the stories legal took down in #200.
 *
 * CONFIRM BEFORE THE HOLD LIFTS: this leans on the REST API knowledge source from the O-Brain page (Linear OPEN-141), which was in Backlog at the last refresh. If it never shipped, rewrite solution_p2 and key_result_2.
 *
 * No stats row and no results table: no figure exists for WeFact anywhere,
 * and a placeholder would be an invented claim. Add the stats, the table and
 * the six-place number check from the customer-stories skill in the same
 * commit that lands cleared figures. */
const WeFactCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="WeFact"
        title={t.customerStories['wefact_hero_title']}
        subtitle={t.customerStories['wefact_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'WeFact',
          customerName: 'WeFact',
          company: t.customerStories['wefact_company_description'],
          industry: t.customerStories['wefact_industry'],
          websiteUrl: 'https://www.wefact.nl',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['wefact_location'],
            },
          ],
          keyResults: [
            t.customerStories['wefact_key_result_1'],
            t.customerStories['wefact_key_result_2'],
            t.customerStories['wefact_key_result_3'],
            t.customerStories['wefact_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['wefact_intro']}</p>

        <h2>{t.customerStories['wefact_challenge_title']}</h2>
        <p>{t.customerStories['wefact_challenge_p1']}</p>
        <p>{t.customerStories['wefact_challenge_p2']}</p>
        <p>{t.customerStories['wefact_challenge_p3']}</p>

        <h2>{t.customerStories['wefact_solution_title']}</h2>
        <p>{t.customerStories['wefact_solution_p1']}</p>
        <p>{t.customerStories['wefact_solution_p2']}</p>
        <p>{t.customerStories['wefact_solution_p3']}</p>

        <h2>{t.customerStories['wefact_impact_title']}</h2>
        <p>{t.customerStories['wefact_impact_p1']}</p>
        <p>{t.customerStories['wefact_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default WeFactCaseStudy;
